import { CircularProgress } from '@mui/material';
import { rgba } from 'polished';
import * as React from 'react';
import LoadingOverlay from 'react-loading-overlay-ts';
// shut the warning up
// https://github.com/derrickpelletier/react-loading-overlay/pull/57
(LoadingOverlay as any).propTypes = undefined;

export type SpinnerSize = 'small' | 'medium' | 'large';

export type SpinProps = {
	size?: number | string;
	spinning?: boolean;
	tip?: string;
	children?: React.ReactNode;
	style?: React.CSSProperties; //unused
	hideBackground?: boolean; //unused
	height?: string;
	minHeight?: number;
	wrapperStyle?: React.CSSProperties;
	overlayContentStyle?: React.CSSProperties;
};

export const Spin = (props: SpinProps) => {
	let w = 16;
	switch (props.size) {
		case 'large':
			w = 100;
			break;
		case 'medium':
			w = 60;
			break;
	}
	const styles = {
		wrapper: (base: any) => ({
			...base,
			...(props.wrapperStyle ?? {}),
			minHeight: props.minHeight,
			height: props.height ?? '100%'
		}),
		overlay: (base: any) => ({
			...base,
			fontSize: '16px',
			background: props.hideBackground ? rgba(0, 0, 0, 0) : rgba(0, 0, 0, 0.25),
			//borderRadius: '5px',
			fontWeight: 300
		}),
		spinner: (base: any) => ({
			...base,
			width: `${w}px`
		}),
		content: (base: any) => ({
			...base,
			...(props.overlayContentStyle ?? {})
		})
	};

	return (
		<LoadingOverlay
			active={props.spinning}
			spinner={<CircularProgress size={props.size ?? '1rem'} />}
			text={props.tip}
			styles={styles as unknown}
		>
			{props.children}
		</LoadingOverlay>
	);
};
